import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  ruleTree: [],
  searchTree: [],
  selectedRule: {},
  selectedPart: {},
  matrices: [],
  matricesData: [],
  cacheAssemblies: [],
  cacheParts: [],
  dbSrc: 'prd',
  searchTerm: '',
  searchType: 'All',
  cacheSearchType: 'PartNumber',
  ruleTab: 'search',
  cacheSearch: '',
  cacheTab: 'assemblies',
  parts: [],
  partAttribute: []
};

const rulesSlice = createSlice({
  name: 'rules',
  initialState,
  reducers: {
    setRuleTree(state, action) {
      state.ruleTree = action.payload;
    },
    setSearchTree(state, action) {
      state.searchTree = action.payload;
    },
    setSelectedRule(state, action) {
      state.selectedRule = action.payload;
    },
    setSelectedPart(state, action) {
      state.selectedPart = action.payload;
    },
    setMatrices(state, action) {
      state.matrices = action.payload;
    },
    setMatricesData(state, action) {
      state.matricesData = action.payload;
    },
    setCacheAssemblies(state, action) {
      state.cacheAssemblies = action.payload;
    },
    setCacheParts(state, action) {
      state.cacheParts = action.payload;
    },
    setDbSrc(state, action) {
      state.dbSrc = action.payload;
    },
    setSearchTerm(state, action) {
      state.searchTerm = action.payload;
    },
    setSearchType(state, action) {
      state.searchType = action.payload;
    },
    setCacheSearchType(state, action) {
      state.cacheSearchType = action.payload;
    },
    setRuleTab(state, action) {
      state.ruleTab = action.payload;
    },
    setCacheSearch(state, action) {
      state.cacheSearch = action.payload;
    },
    setCacheTab(state, action) {
      state.cacheTab = action.payload;
    },
    setParts(state, action) {
      state.parts = action.payload;
    },
    addPartAttribute(state, action) {
      if (!state.partAttribute.includes(action.payload)) {
        state.partAttribute.push(action.payload);
      }
    },
    delPartAttribute(state, action) {
      state.partAttribute = state.partAttribute.filter(attr => attr !== action.payload);
    },
    setPartAttribute(state, action) {
      state.partAttribute = action.payload;
    },
  }
});

export const {
  setRuleTree,
  setSearchTree,
  setSelectedRule,
  setSelectedPart,
  setMatrices,
  setMatricesData,
  setCacheAssemblies,
  setCacheParts,
  setDbSrc,
  setSearchTerm,
  setSearchType,
  setCacheSearchType,
  setRuleTab,
  setCacheSearch,
  setCacheTab,
  setParts,
  addPartAttribute,
  delPartAttribute,
  setPartAttribute,
} = rulesSlice.actions;

export default rulesSlice.reducer;
